var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 216,
    viewBox: "0 0 262 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_433)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.366 32H52.2809C43.3658 32 36.1387 39.231 36.1387 48.1509V191.49C36.1387 200.41 43.3658 207.641 52.2809 207.641H175.366C184.28 207.641 191.508 200.41 191.508 191.49V48.1509C191.508 39.231 184.28 32 175.366 32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.543 72H53.5C51.0147 72 49 74.0147 49 76.5C49 78.9853 51.0147 81 53.5 81H177.543C180.028 81 182.043 78.9853 182.043 76.5C182.043 74.0147 180.028 72 177.543 72Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.821 97H53.5C51.0147 97 49 99.0147 49 101.5C49 103.985 51.0147 106 53.5 106H126.821C129.306 106 131.321 103.985 131.321 101.5C131.321 99.0147 129.306 97 126.821 97Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 122H53.5C51.0147 122 49 124.015 49 126.5C49 128.985 51.0147 131 53.5 131H197.5C199.985 131 202 128.985 202 126.5C202 124.015 199.985 122 197.5 122Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.755 147H53.5C51.0147 147 49 149.015 49 151.5C49 153.985 51.0147 156 53.5 156H156.755C159.24 156 161.255 153.985 161.255 151.5C161.255 149.015 159.24 147 156.755 147Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.696 172H53.5C51.0147 172 49 174.015 49 176.5C49 178.985 51.0147 181 53.5 181H107.696C110.181 181 112.196 178.985 112.196 176.5C112.196 174.015 110.181 172 107.696 172Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1598_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#FFFDB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 24.25H26.5V28.75H25V24.25ZM21.25 25.75H22.75V28.75H21.25V25.75ZM17.5 21.25H19V28.75H17.5V21.25Z",
    fill: "#05C25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5004 37.4395L32.8364 31.7755C34.0741 30.2963 34.7517 28.4287 34.7504 26.5C34.7504 21.9513 31.0491 18.25 26.5004 18.25C24.6981 18.25 22.9866 18.82 21.5496 19.9L22.4496 21.1C23.6162 20.2196 25.0389 19.7455 26.5004 19.75C30.2226 19.75 33.2504 22.7778 33.2504 26.5C33.2504 30.2222 30.2226 33.25 26.5004 33.25C25.4518 33.2541 24.4168 33.0119 23.4789 32.543C22.541 32.074 21.7263 31.3914 21.1004 30.55L19.9004 31.4515C20.6657 32.4793 21.6616 33.3132 22.8079 33.8861C23.9542 34.459 25.2189 34.7549 26.5004 34.75C28.5051 34.75 30.3449 34.03 31.7759 32.836L37.4399 38.5L38.5004 37.4395Z",
    fill: "#05C25E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1598_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.699 60H122.301C115.507 60 110 63.3019 110 67.375V170.625C110 174.698 115.507 178 122.301 178H240.699C247.493 178 253 174.698 253 170.625V67.375C253 63.3019 247.493 60 240.699 60Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140 96H131C128.791 96 127 97.7909 127 100V159C127 161.209 128.791 163 131 163H140C142.209 163 144 161.209 144 159V100C144 97.7909 142.209 96 140 96Z",
    fill: "#AACC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 125H155C152.791 125 151 126.791 151 129V159C151 161.209 152.791 163 155 163H164C166.209 163 168 161.209 168 159V129C168 126.791 166.209 125 164 125Z",
    fill: "#AACC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 85H179C176.791 85 175 86.7909 175 89V159C175 161.209 176.791 163 179 163H188C190.209 163 192 161.209 192 159V89C192 86.7909 190.209 85 188 85Z",
    fill: "#AACC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 115H203C200.791 115 199 116.791 199 119V159C199 161.209 200.791 163 203 163H212C214.209 163 216 161.209 216 159V119C216 116.791 214.209 115 212 115Z",
    fill: "#AACC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 115H227C224.791 115 223 116.791 223 119V159C223 161.209 224.791 163 227 163H236C238.209 163 240 161.209 240 159V119C240 116.791 238.209 115 236 115Z",
    fill: "#AACC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_433",
    x: 32.1387,
    y: 32,
    width: 163.369,
    height: 183.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1598_433",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1598_433",
    x: 110,
    y: 60,
    width: 152,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 216,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home_1.4419612f2e31776e5d68e0c9ccdda7ac.svg";
export { ForwardRef as ReactComponent };